import React from "react";
import BannerRoot from "../BannerRoot";
import styles from "./index.module.scss";
import Button from "../../../UI/Button";
import scrollToElement from "../../../../utils/scrollToElement";

const CompleteRenewalBanner = () => {
  return (
    <BannerRoot className={styles.modal}>
      <div className={styles.wrapper}>
        <h3 className={styles.title}>
          Complete the Renewal CRs to see the extended report
        </h3>

        <Button
          onClick={() => scrollToElement("revenue-calculator")}
          title="Add more data"
          size="large"
          className={styles.button}
          type="submit"
        />
      </div>
    </BannerRoot>
  );
};

export default CompleteRenewalBanner;
